import { useState, type FormEvent } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '@/lib/supabase'
import { Logo } from '@/components/ui/Logo'
import { FormField } from '@/components/ui/FormField'

export default function ResetPassword() {
  const navigate = useNavigate()
  const [password,  setPassword]  = useState('')
  const [confirm,   setConfirm]   = useState('')
  const [loading,   setLoading]   = useState(false)
  const [done,      setDone]      = useState(false)
  const [error,     setError]     = useState('')

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault()
    if (loading) return
    if (!password.trim()) { setError('Password is required.'); return }
    if (password.length < 8) { setError('Password must be at least 8 characters.'); return }
    if (password !== confirm)  { setError('Passwords do not match.'); return }
    setError('')
    setLoading(true)
    try {
      const { error: updateError } = await supabase.auth.updateUser({ password })
      if (updateError) {
        setError(updateError.message.includes('same password')
          ? 'New password must be different from your current one.'
          : 'Password reset failed. The link may have expired.')
        return
      }
      setDone(true)
      setTimeout(() => navigate('/login', { replace: true }), 2500)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', padding: '24px 16px', background: '#FAF6EF',
    }}>
      <div style={{ width: '100%', maxWidth: 420 }}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 22 }}>
          <Logo size={28} onClick={() => navigate('/')} />
        </div>

        <div style={{
          background: '#fff', border: '1px solid rgba(27,42,74,0.08)',
          borderRadius: 18, padding: '28px 24px',
        }}>
          {done ? (
            <>
              <div className='banner-success' style={{ textAlign: 'center' }}>
                Password updated. Redirecting to log in…
              </div>
            </>
          ) : (
            <>
              <div style={{ font: '600 22px Lora,serif', color: '#1B2A4A', textAlign: 'center' }}>
                Set a new password
              </div>
              <div style={{ font: '400 13px Inter,sans-serif', color: 'rgba(27,42,74,0.55)', textAlign: 'center', marginTop: 5, marginBottom: 20 }}>
                Choose a strong password for your account
              </div>

              <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
                <FormField
                  label='New password'
                  type='password'
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  placeholder='At least 8 characters'
                  autoComplete='new-password'
                  required
                />
                <FormField
                  label='Confirm new password'
                  type='password'
                  value={confirm}
                  onChange={e => setConfirm(e.target.value)}
                  placeholder='Repeat your new password'
                  autoComplete='new-password'
                  required
                />
                {error && <div className='banner-error'>{error}</div>}
                <button type='submit' className='btn-primary' disabled={loading}>
                  {loading ? 'Saving…' : 'Set new password'}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
